/** Volání print_* toolů: chyba s kódem a její hláška pro uživatele. Sdílí Statistiky i Ceny. */
import type { TFunction } from 'i18next';
import { printErrorKey } from './print-stats-logic';
import type { ToolFail } from './print-stats-types';

export class PrintCallError extends Error {
  readonly code: string;
  readonly customers: string[];

  constructor(code: string, customers: string[]) {
    super(code);
    this.name = 'PrintCallError';
    this.code = code;
    this.customers = customers;
  }
}

export function unwrap<T extends { ok: true }>(
  value: T | ToolFail | null | undefined,
  fallback: string,
): T {
  if (!value || value.ok !== true) {
    const code = (value && value.error) || fallback;
    const customers = (value?.customers ?? []).filter((item) => item.trim());
    throw new PrintCallError(code, customers);
  }
  return value;
}

export function explainPrintError(t: TFunction, error: unknown, fallback: string): string {
  const code = error instanceof PrintCallError
    ? error.code
    : error instanceof Error
    ? error.message
    : '';
  const key = code ? printErrorKey(code) : null;
  if (key) return t(key);
  if (error instanceof Error && error.message && !/^[a-z0-9_]+$/.test(error.message)) {
    return error.message;
  }
  return fallback;
}
